import { useCallback, useEffect, useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Choice } from './choice';

// Helper function to chunk the items into rows
const chunkArray = (arr, chunkSize) => {
  const chunkedArray = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    chunkedArray.push(arr.slice(i, i + chunkSize));
  }
  return chunkedArray;
};

export function HearingChoices({
  choices,
  changeActiveAudioSrc,
  activeAudioSrc,
  onPressChoice,
  playbackRate = 1.0,
}) {
  const [disable, setDisable] = useState(false);
  const choicesDep = JSON.stringify(choices);

  const finishedExercise = useCallback(() => {
    choices.find((choice) => {
      if (choice.isCorrect && choice.isPressed) {
        setDisable(true);
        return;
      }
    });
  }, [choices]);

  const disableAll = useCallback(() => {
    setDisable(true);
  }, []);

  const responsiveStyles = StyleSheet.create({
    container: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
    },
    row: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 32,
    },
  });

  const items = useMemo(() => {
    let choicesCloned = [...choices];
    if (choicesCloned.length === 3) {
      choicesCloned.push('_EMPTY');
    }
    return choicesCloned.map((choice) => {
      if (choice === '_EMPTY') {
        const key = choice;
        return <View key={key} />;
      }
      const key = choice.choiceAudio;
      return (
        <View key={key}>
          <Choice
            changeActiveAudioSrc={changeActiveAudioSrc}
            activeAudioSrc={activeAudioSrc}
            disableAll={disableAll}
            isDisabled={disable}
            choice={choice}
            onPressChoice={onPressChoice}
            playbackRate={playbackRate}
          />
        </View>
      );
    });
  }, [choicesDep, disable, activeAudioSrc]);

  const rows = useMemo(() => chunkArray(items, 2), [items]);

  useEffect(() => {
    setDisable(false);
    finishedExercise();
  }, [choicesDep]);

  return (
    <View style={responsiveStyles.container}>
      {rows.map((row, index) => (
        <View key={index} style={responsiveStyles.row}>
          {row}
        </View>
      ))}
    </View>
  );
}
